import React from "react";
import "../../App";
import Seo from "../Seo";

const TermsHeader = () => {
  const heroStyles = {
    container: {
      marginBottom: 0,
      minHeight: "50vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      paddingTop: "100px",
      paddingBottom: "60px"
    },
    content: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heading: {
      fontSize: "clamp(2rem, 6vw, 3.5rem)",
      fontWeight: "700",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
      marginBottom: "24px",
      textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)"
    },
    subtitle: {
      fontSize: "1.25rem",
      opacity: 0.9
    }
  };

  return (
    <div>
      <Seo
        title="Terms & Conditions | NeedForGeeks"
        description="The terms and conditions governing NeedForGeeks tech services for clients in New York."
        path="/terms-and-conditions"
      />
      <div
        id="termsHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light"
        style={heroStyles.container}
      >
        <div style={heroStyles.content} className="container container-fluid text-center">
          <h1 style={heroStyles.heading}>Terms and Conditions</h1>
          <p style={heroStyles.subtitle}>Please review our terms of service</p>
        </div>
      </div>
    </div>
  );
};

export default TermsHeader;

